import { Button, Icon, Space, Text } from '@pyt/ui/components'
import { above } from '@pyt/ui/utils/device'
import styled, { css } from 'styled-components'

const Wrapper = styled.div`
	position: fixed;
	width: calc(100% - 40px);
	background: #fff;
	box-shadow: 0 0 15px 3px rgba(0, 0, 0, 0.12);
	border-radius: 8px;
	padding: 24px;
	left: 20px;
	bottom: -110%;
	transition: all 700ms ease-in-out;
	z-index: 1500;
	text-align: center;

	${({ show }) =>
		show &&
		css`
			bottom: 20px;
		`}

	${above('mobile')} {
		width: 320px;
		text-align: left;
	}
`

const CloseIcon = styled(Icon)`
	position: absolute;
	right: 16px;
	top: 16px;
`

const ButtonWrapper = styled(Button)`
	text-transform: capitalize;
	font-size: 15px;
	line-height: 19px;
	font-weight: 600;

	${above('mobile')} {
		font-size: 13px;
		line-height: 16px;
	}
`

const CountryConfirmationDialog = ({
	show = false,
	userCountry = 'United Arab Emirates',
	currentCountry = 'India',
	onClickPrimary = () => false,
	onClickSecondary = () => false,
	onClose = () => false,
}) => {
	return (
		<Wrapper show={show}>
			<CloseIcon icon="pyt-close-circle-16" onClick={onClose} />
			<Space direction="vertical" gutter={[24]}>
				<Text
					fontSize={['17px', '15px']}
					lineHeight={['28px', '24px']}
					fontWeight={600}
				>
					We think you are in {userCountry}. <br />
					Update your location?
				</Text>
				<Space>
					<ButtonWrapper variant="primary" onClick={onClickPrimary}>
						{userCountry}
					</ButtonWrapper>
					<ButtonWrapper variant="default" onClick={onClickSecondary}>
						{currentCountry}
					</ButtonWrapper>
				</Space>
			</Space>
		</Wrapper>
	)
}

export default CountryConfirmationDialog
